import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../session-storage/session-storage.service';
import { SessionStorageNames } from '../../enums/session-storage-names.enum';

@Injectable({
  providedIn: 'root'
})
export class ReloadPageService {
  private _isReloaded = false;
  private sessionStorageService = inject(SessionStorageService);
  constructor() { }

  get isReloaded() {
    return this._isReloaded;
  }

  get currentUrl() {
    return this.sessionStorageService.get(SessionStorageNames.CURRENT_URL);
  }

  isUrlReloaded(url: string) {
    this._isReloaded = url === this.currentUrl;
    if(!this.isReloaded) this.setCurrentUrl(url);
    return this.isReloaded;
  }

  setCurrentUrl(url: string) {
    this.sessionStorageService.set(SessionStorageNames.CURRENT_URL, url);
  }
}
